module.exports = __webpack_public_path__ + "static/media/faq-header-tablet.834b52a9.jpg";